import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { GraduationCap, CheckCircle2, Circle, RefreshCw } from "lucide-react";

export const RehearsalScoreboard = () => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = async () => { setBusy(true); try { const { data } = await api.get("/rehearsal/scoreboard"); setData(data); } catch {} finally { setBusy(false); } };
  useEffect(() => { load(); }, []);
  if (!data) return null;
  const pct = data.total ? Math.round((data.rehearsed / data.total) * 100) : 0;
  return (
    <div className="border border-white/10 mt-6" data-testid="rehearsal-scoreboard">
      <div className="px-4 py-3 border-b border-white/10 flex items-center gap-4 flex-wrap">
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-zinc-500"><GraduationCap size={13}/>Offline rehearsal</div>
        <div className="text-sm" data-testid="rehearsal-summary"><span className="text-emerald-300 font-semibold">{data.rehearsed}</span> of {data.total} agents rehearsed · <span className={data.pending ? "text-amber-300" : "text-zinc-400"}>{data.pending} to go</span></div>
        <div className="flex-1 min-w-[120px] h-1.5 bg-white/5 relative overflow-hidden"><div className="absolute inset-y-0 left-0 bg-emerald-400 transition-[width]" style={{ width: `${pct}%` }}/></div>
        <button onClick={load} disabled={busy} className="text-xs text-zinc-400 hover:text-white flex items-center gap-1 disabled:opacity-50" data-testid="rehearsal-refresh-btn"><RefreshCw size={12} className={busy ? "animate-spin" : ""}/>Refresh</button>
      </div>
      {data.total === 0 ? <div className="px-4 py-4 text-xs text-zinc-500">No agents yet.</div> : (
        <div className="divide-y divide-white/5 max-h-72 overflow-y-auto">
          {data.agents.map(a => (
            <div key={a.id} className="px-4 py-2 flex items-center gap-3 text-xs" data-testid={`rehearsal-row-${a.id}`} data-rehearsed={a.rehearsed}>
              {a.rehearsed ? <CheckCircle2 size={14} className="text-emerald-400 shrink-0"/> : <Circle size={14} className={`shrink-0 ${a.active ? "text-amber-400" : "text-zinc-600"}`}/>}
              <div className="flex-1 min-w-0">
                <div className="truncate text-zinc-200">{a.name} <span className="text-zinc-500">· {a.email}</span></div>
                <div className="text-[11px] text-zinc-500">
                  {a.rehearsed ? `Rehearsed ${a.rehearsal_count || 1}× · last ${String(a.rehearsal_completed_at).slice(0, 16).replace("T", " ")}${a.rehearsal_last?.had_photo ? " · with photo" : ""}`
                    : a.active ? "Signed in but has not rehearsed yet" : "Never signed in — resend invite"}
                </div>
              </div>
              <div className="text-[11px] text-zinc-500 tabular shrink-0">{a.assigned_pus} PU{a.assigned_pus === 1 ? "" : "s"}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
